<template>
  <div class=" ">
    <slot />
    <div class="flex justify-center space-x-2 -mt-1" v-if="getISActive">
      <button
        @click="$router.push({ name: 'confirm.unsubscribe' })"
        class="sub-btn-bg text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
      >
        إلفاء الإشتراك
      </button>

      <button
        @click="$router.push({ name: 'confirm.logout' })"
        class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
      >
        تسجيل خروج
      </button>
    </div>
    <div class="flex justify-center space-x-2 -mt-1" v-else>
      <router-link to="/auth/sudani-plans">
        <button
          class="sub-btn-bg text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
        >
          اشترك الان
        </button>
      </router-link>
      <router-link to="/login">
        <button
          class="border border-color text-white text-center rounded-md md:py-1 md:px-8 px-4 py-2 md:text-[1.2vw] text-[12px] truncate"
        >
          تسجيل دخول
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { mapState } from "pinia";
export default {
  components: {
    // SpinnerView,
  },
  computed: {
    ...mapState(useAuthStore, ["getISActive"]),
  },
  methods: {}, //end of methods
};
</script>

<style></style>
